import { Box, Typography } from "@mui/material";
import { useTranslate } from "react-admin";

import type { CustomerServiceCrmRecordQuery } from "../../generated/graphql";
import { CRM_COLORS } from "../../lib/crm";
import { InventoryTable } from "../logistics/InventoryTable";
import { DeletedInSalesforceBadge } from "./DeletedInSalesforceBadge";

type RecordData = NonNullable<CustomerServiceCrmRecordQuery["customerServiceCrmRecord"]>;

const noteSx = { px: "8px", fontSize: "13px", color: CRM_COLORS.label };

export const ContractItemAsset = ({ asset }: { asset: RecordData["contractItemAsset"] }) => {
  const translate = useTranslate();
  if (!asset)
    return <Typography sx={{ ...noteSx, color: CRM_COLORS.textWeak }}>{translate("crm.related.empty")}</Typography>;
  const units = ["tablet", "sim", "hardware"] as const;
  return (
    <Box>
      <Box sx={{ ...noteSx, mb: "12px" }}>
        <Typography component="div" sx={{ fontSize: "14px", color: CRM_COLORS.text }}>
          {translate("crm.contractItem.assetReference", { name: asset.name ?? asset.salesforceId })}
          {asset.deletedInSalesforceAt && <DeletedInSalesforceBadge deletedAt={asset.deletedInSalesforceAt} />}
        </Typography>
        <Typography sx={{ fontSize: "13px" }}>{translate("crm.contractItem.assetPlacementNote")}</Typography>
      </Box>
      <InventoryTable
        label={translate("logistics.inventory.title")}
        empty={translate("crm.related.empty")}
        rows={units.flatMap(slot => {
          const inventory = asset[slot];
          return inventory ? [{ key: slot, inventory }] : [];
        })}
      />
    </Box>
  );
};
